.button-wrapper {
  align-items: center;
  justify-content: center;
  height: 100%;
}

.receive-button {
  height: 24px;
}
